export const DTR_TAG_CLASS = 'text-editor-dynamic-tag';
export const REMOVE_BUTTON_CLASS = 'text-editor-dynamic-tag-close svg-ico-close-dialog';
export const DTR_TAG_BORDER_WIDTH = 2;
export const DTR_TAG_BORDER_PADDING = DTR_TAG_BORDER_WIDTH * 2;
export const DTR_TAG_BORDER_OFFSET = 4;
export const REMOVE_BUTTON_MIN_HEIGHT = 10;



// WEBPACK FOOTER //
// ./src/ui/inline-text/dynamic-text-defaults.js